import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const SettingsPage = Loadable(
  lazy(() => import("../pages/settings/AddSettings"))
);

const AddAdmin = Loadable(
  lazy(() => import("../pages/admins/admins/AddAdmin"))
);
// const Dashboard = Loadable(lazy(() => import("../pages/dashboard/Dashboard")));

const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view"))
);
const AddPrivilegs = Loadable(
  lazy(() => import("../pages/admins/privileges/AddPrivilegs"))
);

const CategoryPage = Loadable(
  lazy(() => import("../pages/categories/CategoryPage"))
);
const AddCategory = Loadable(
  lazy(() => import("../pages/categories/AddCategory"))
);

const TestimonialPage = Loadable(
  lazy(() => import("../pages/testimonials/TestimonialsPage"))
);
const AddTestimonials = Loadable(
  lazy(() => import("../pages/testimonials/AddTestimonials"))
);

const ProjectsPage = Loadable(
  lazy(() => import("../pages/projects/ProjectsPage"))
);
const AddProjects = Loadable(
  lazy(() => import("../pages/projects/AddProjects"))
);

const AddWebsiteManagment = Loadable(
  lazy(() => import("../pages/website-managment/AddWebsiteManagment"))
);

const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login"))
);
const ContactPage = Loadable(
  lazy(() => import("../pages/contact/ContactPage"))
);
const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);

const FaqPage = Loadable(lazy(() => import("../pages/faq/FaqPage")));
const AddFaq = Loadable(lazy(() => import("../pages/faq/AddFaq")));

const ContactPageMain = Loadable(
  lazy(() => import("../pages/contact-page/ContactPage"))
);

let data = getLocalStorage(dataLocalStorage.privileges);
console.log("data : ", data);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      data["67b9e7e733e6ec1a046210c4"]?.access_read === 1 && {
        path: RouterName.website.addWebsite,
        exact: true,
        element: <AddWebsiteManagment />,
      },
      data["67b9e7e733e6ec1a046210c4"]?.access_read === 1 && {
        path: RouterName.contactPage.contactPage,
        exact: true,
        element: <ContactPageMain />,
      },

      data["67c303017e6576da6dbb31f2"]?.access_read === 1 && {
        path: RouterName.faq.faq,
        exact: true,
        element: <FaqPage />,
      },
      (data["67c303017e6576da6dbb31f2"]?.access_write === 1 ||
        data["67c303017e6576da6dbb31f2"]?.access_edit === 1) && {
        path: `${RouterName.faq.addFaq}/:id?`,
        exact: true,
        element: <AddFaq />,
      },

      data["67b3a6c144b33d5ca72ae599"]?.access_read === 1 && {
        path: RouterName.categories.categories,
        exact: true,
        element: <CategoryPage />,
      },
      (data["67b3a6c144b33d5ca72ae599"]?.access_write === 1 ||
        data["67b3a6c144b33d5ca72ae599"]?.access_edit === 1) && {
        path: `${RouterName.categories.addCategories}/:id?`,
        exact: true,
        element: <AddCategory />,
      },

      data["67ae5ff46827b98fd43ae8c6"]?.access_read === 1 && {
        path: RouterName.projects.projects,
        exact: true,
        element: <ProjectsPage />,
      },
      (data["67ae5ff46827b98fd43ae8c6"]?.access_write === 1 ||
        data["67ae5ff46827b98fd43ae8c6"]?.access_edit === 1) && {
        path: `${RouterName.projects.addProjects}/:id?`,
        exact: true,
        element: <AddProjects />,
      },

      data["67ae5f87e059fd5875cb051f"]?.access_read === 1 && {
        path: RouterName.settings.settings,
        exact: true,
        element: <SettingsPage />,
      },
      data["67ae52171ff043a4b674af5c"]?.access_read === 1 && {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },
      (data["67ae52171ff043a4b674af5c"]?.access_write === 1 ||
        data["67ae52171ff043a4b674af5c"]?.access_edit === 1) && {
        path: `${RouterName.admins.addAdmins}/:id?`,
        exact: true,
        element: <AddAdmin />,
      },
      data["67ae52171ff043a4b674af5c"]?.access_read === 1 && {
        path: `${RouterName.privileges.privileges}`,
        exact: true,
        element: <PrivilegesPage />,
      },
      (data["67ae52171ff043a4b674af5c"]?.access_write === 1 ||
        data["67ae52171ff043a4b674af5c"]?.access_edit === 1) && {
        path: `${RouterName.privileges.addPrivileges}/:id?`,
        exact: true,
        element: <AddPrivilegs />,
      },

      data["67b1fdf6e69c8c393e4c1178"]?.access_read === 1 && {
        path: `${RouterName.contact.contact}`,
        exact: true,
        element: <ContactPage />,
      },

      data["67b1ff6ae69c8c393e4c119b"]?.access_read === 1 && {
        path: `${RouterName.testimonial.testimonial}`,
        exact: true,
        element: <TestimonialPage />,
      },
      (data["67b1ff6ae69c8c393e4c119b"]?.access_write === 1 ||
        data["67b1ff6ae69c8c393e4c119b"]?.access_edit === 1) && {
        path: `${RouterName.testimonial.addTestimonial}/:id?`,
        exact: true,
        element: <AddTestimonials />,
      },

      // data["66feabcd064614233631202f"]?.access_read === 1 && {
      //   path: "/client",
      //   exact: true,
      //   element: <UsersList />,
      // },
      // (data["66feabcd064614233631202f"]?.access_write === 1 ||
      //   data["66feabcd064614233631202f"]?.access_edit === 1) && {
      //   path: "/client/create/:id?",
      //   exact: true,
      //   element: <AddUser />,
      // },
      // data["671f4a4af22b69689dce2a73"]?.access_read === 1 && {
      //   path: "/logs",
      //   exact: true,
      //   element: <LogsList />,
      // },

      { path: "/404", element: <Error /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
